// AUTO-GENERATED by scripts/optimize-images.mjs — do not edit by hand.
// Run `npm run optimize:images` to regenerate.
export const IMAGE_MANIFEST = {
  "art-choice-machine": {
    "stem": "art-choice-machine",
    "originalSrc": "/images/art-choice-machine.jpg",
    "originalWidth": 1024,
    "originalHeight": 1280,
    "widths": [
      480,
      800,
      1024
    ]
  },
  "art-layers": {
    "stem": "art-layers",
    "originalSrc": "/images/art-layers.jpg",
    "originalWidth": 976,
    "originalHeight": 730,
    "widths": [
      480,
      800,
      976
    ]
  },
  "art-life-engineered": {
    "stem": "art-life-engineered",
    "originalSrc": "/images/art-life-engineered.jpg",
    "originalWidth": 1173,
    "originalHeight": 1536,
    "widths": [
      480,
      800,
      1173
    ]
  },
  "art-portrait-01": {
    "stem": "art-portrait-01",
    "originalSrc": "/images/art-portrait-01.jpg",
    "originalWidth": 1064,
    "originalHeight": 1415,
    "widths": [
      480,
      800,
      1064
    ]
  },
  "art-portrait-02": {
    "stem": "art-portrait-02",
    "originalSrc": "/images/art-portrait-02.jpg",
    "originalWidth": 1094,
    "originalHeight": 1417,
    "widths": [
      480,
      800,
      1094
    ]
  },
  "art-portrait-03": {
    "stem": "art-portrait-03",
    "originalSrc": "/images/art-portrait-03.jpg",
    "originalWidth": 1068,
    "originalHeight": 1380,
    "widths": [
      480,
      800,
      1068
    ]
  },
  "art-tech-and-text": {
    "stem": "art-tech-and-text",
    "originalSrc": "/images/art-tech-and-text.jpg",
    "originalWidth": 1221,
    "originalHeight": 1536,
    "widths": [
      480,
      800,
      1200,
      1221
    ]
  },
  "art-through-screen": {
    "stem": "art-through-screen",
    "originalSrc": "/images/art-through-screen.jpg",
    "originalWidth": 1280,
    "originalHeight": 961,
    "widths": [
      480,
      800,
      1200,
      1280
    ]
  },
  "art-traditional": {
    "stem": "art-traditional",
    "originalSrc": "/images/art-traditional.jpg",
    "originalWidth": 1557,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1557
    ]
  },
  "art-upgrading-mind": {
    "stem": "art-upgrading-mind",
    "originalSrc": "/images/art-upgrading-mind.jpg",
    "originalWidth": 1236,
    "originalHeight": 1536,
    "widths": [
      480,
      800,
      1200,
      1236
    ]
  },
  "art-urban-abyss": {
    "stem": "art-urban-abyss",
    "originalSrc": "/images/art-urban-abyss.jpg",
    "originalWidth": 1266,
    "originalHeight": 1536,
    "widths": [
      480,
      800,
      1200,
      1266
    ]
  },
  "art-urban-night": {
    "stem": "art-urban-night",
    "originalSrc": "/images/art-urban-night.jpg",
    "originalWidth": 1206,
    "originalHeight": 795,
    "widths": [
      480,
      800,
      1200,
      1206
    ]
  },
  "art-writes-back": {
    "stem": "art-writes-back",
    "originalSrc": "/images/art-writes-back.jpg",
    "originalWidth": 1280,
    "originalHeight": 961,
    "widths": [
      480,
      800,
      1200,
      1280
    ]
  },
  "avatar": {
    "stem": "avatar",
    "originalSrc": "/images/avatar.jpg",
    "originalWidth": 1240,
    "originalHeight": 1550,
    "widths": [
      480,
      800,
      1200,
      1240
    ]
  },
  "brand-closing": {
    "stem": "brand-closing",
    "originalSrc": "/images/brand-closing.jpg",
    "originalWidth": 2048,
    "originalHeight": 1229,
    "widths": [
      480,
      800,
      1200,
      1800,
      2048
    ]
  },
  "brand-hero": {
    "stem": "brand-hero",
    "originalSrc": "/images/brand-hero.jpg",
    "originalWidth": 2048,
    "originalHeight": 1229,
    "widths": [
      480,
      800,
      1200,
      1800,
      2048
    ]
  },
  "brand-moment-1": {
    "stem": "brand-moment-1",
    "originalSrc": "/images/brand-moment-1.jpg",
    "originalWidth": 936,
    "originalHeight": 564,
    "widths": [
      480,
      800,
      936
    ]
  },
  "brand-moment-2": {
    "stem": "brand-moment-2",
    "originalSrc": "/images/brand-moment-2.jpg",
    "originalWidth": 936,
    "originalHeight": 562,
    "widths": [
      480,
      800,
      936
    ]
  },
  "brand-type-1": {
    "stem": "brand-type-1",
    "originalSrc": "/images/brand-type-1.jpg",
    "originalWidth": 1365,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1365
    ]
  },
  "brand-type-2": {
    "stem": "brand-type-2",
    "originalSrc": "/images/brand-type-2.jpg",
    "originalWidth": 1365,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1365
    ]
  },
  "brand-type-3": {
    "stem": "brand-type-3",
    "originalSrc": "/images/brand-type-3.jpg",
    "originalWidth": 1365,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1365
    ]
  },
  "brand-type-4": {
    "stem": "brand-type-4",
    "originalSrc": "/images/brand-type-4.jpg",
    "originalWidth": 1569,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1569
    ]
  },
  "club-activity-art-smile": {
    "stem": "club-activity-art-smile",
    "originalSrc": "/images/club-activity-art-smile.jpg",
    "originalWidth": 1080,
    "originalHeight": 1620,
    "widths": [
      480,
      800,
      1080
    ]
  },
  "club-activity-color-play": {
    "stem": "club-activity-color-play",
    "originalSrc": "/images/club-activity-color-play.jpg",
    "originalWidth": 1620,
    "originalHeight": 1080,
    "widths": [
      480,
      800,
      1200,
      1620
    ]
  },
  "club-activity-community-stage": {
    "stem": "club-activity-community-stage",
    "originalSrc": "/images/club-activity-community-stage.jpg",
    "originalWidth": 2500,
    "originalHeight": 1875,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2500
    ]
  },
  "club-activity-family-play": {
    "stem": "club-activity-family-play",
    "originalSrc": "/images/club-activity-family-play.jpg",
    "originalWidth": 1620,
    "originalHeight": 1080,
    "widths": [
      480,
      800,
      1200,
      1620
    ]
  },
  "club-activity-painting-01": {
    "stem": "club-activity-painting-01",
    "originalSrc": "/images/club-activity-painting-01.jpg",
    "originalWidth": 1875,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      1875
    ]
  },
  "club-activity-playground-01": {
    "stem": "club-activity-playground-01",
    "originalSrc": "/images/club-activity-playground-01.jpg",
    "originalWidth": 1080,
    "originalHeight": 1620,
    "widths": [
      480,
      800,
      1080
    ]
  },
  "club-activity-playground-02": {
    "stem": "club-activity-playground-02",
    "originalSrc": "/images/club-activity-playground-02.jpg",
    "originalWidth": 1080,
    "originalHeight": 1620,
    "widths": [
      480,
      800,
      1080
    ]
  },
  "club-activity-sketching-01": {
    "stem": "club-activity-sketching-01",
    "originalSrc": "/images/club-activity-sketching-01.jpg",
    "originalWidth": 2500,
    "originalHeight": 1875,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2500
    ]
  },
  "club-activity-studio-setup": {
    "stem": "club-activity-studio-setup",
    "originalSrc": "/images/club-activity-studio-setup.jpg",
    "originalWidth": 2500,
    "originalHeight": 1875,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2500
    ]
  },
  "club-activity-volunteers": {
    "stem": "club-activity-volunteers",
    "originalSrc": "/images/club-activity-volunteers.jpg",
    "originalWidth": 2500,
    "originalHeight": 1875,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2500
    ]
  },
  "club-activity-workshop-01": {
    "stem": "club-activity-workshop-01",
    "originalSrc": "/images/club-activity-workshop-01.jpg",
    "originalWidth": 2500,
    "originalHeight": 1875,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2500
    ]
  },
  "club-activity-workshop-02": {
    "stem": "club-activity-workshop-02",
    "originalSrc": "/images/club-activity-workshop-02.jpg",
    "originalWidth": 1875,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      1875
    ]
  },
  "club-footer": {
    "stem": "club-footer",
    "originalSrc": "/images/club-footer.jpg",
    "originalWidth": 1206,
    "originalHeight": 670,
    "widths": [
      480,
      800,
      1200,
      1206
    ]
  },
  "club-hero": {
    "stem": "club-hero",
    "originalSrc": "/images/club-hero.jpg",
    "originalWidth": 936,
    "originalHeight": 624,
    "widths": [
      480,
      800,
      936
    ]
  },
  "contact-hero": {
    "stem": "contact-hero",
    "originalSrc": "/images/contact-hero.jpg",
    "originalWidth": 1206,
    "originalHeight": 1507,
    "widths": [
      480,
      800,
      1200,
      1206
    ]
  },
  "contact-side": {
    "stem": "contact-side",
    "originalSrc": "/images/contact-side.jpg",
    "originalWidth": 468,
    "originalHeight": 603,
    "widths": [
      468
    ]
  },
  "home-footer": {
    "stem": "home-footer",
    "originalSrc": "/images/home-footer.jpg",
    "originalWidth": 2048,
    "originalHeight": 1153,
    "widths": [
      480,
      800,
      1200,
      1800,
      2048
    ]
  },
  "home-hero": {
    "stem": "home-hero",
    "originalSrc": "/images/home-hero.jpg",
    "originalWidth": 2048,
    "originalHeight": 1152,
    "widths": [
      480,
      800,
      1200,
      1800,
      2048
    ]
  },
  "portfolio-choice-machine": {
    "stem": "portfolio-choice-machine",
    "originalSrc": "/images/portfolio-choice-machine.jpg",
    "originalWidth": 1024,
    "originalHeight": 1280,
    "widths": [
      480,
      800,
      1024
    ]
  },
  "portfolio-choice-writes-back": {
    "stem": "portfolio-choice-writes-back",
    "originalSrc": "/images/portfolio-choice-writes-back.jpg",
    "originalWidth": 1280,
    "originalHeight": 961,
    "widths": [
      480,
      800,
      1200,
      1280
    ]
  },
  "portfolio-footer": {
    "stem": "portfolio-footer",
    "originalSrc": "/images/portfolio-footer.jpg",
    "originalWidth": 1206,
    "originalHeight": 795,
    "widths": [
      480,
      800,
      1200,
      1206
    ]
  },
  "portfolio-hero": {
    "stem": "portfolio-hero",
    "originalSrc": "/images/portfolio-hero.jpg",
    "originalWidth": 1183,
    "originalHeight": 747,
    "widths": [
      480,
      800,
      1183
    ]
  },
  "portfolio-layers-of-identity": {
    "stem": "portfolio-layers-of-identity",
    "originalSrc": "/images/portfolio-layers-of-identity.jpg",
    "originalWidth": 976,
    "originalHeight": 730,
    "widths": [
      480,
      800,
      976
    ]
  },
  "portfolio-life-engineered": {
    "stem": "portfolio-life-engineered",
    "originalSrc": "/images/portfolio-life-engineered.jpg",
    "originalWidth": 1909,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      1909
    ]
  },
  "portfolio-mechanical-entanglement": {
    "stem": "portfolio-mechanical-entanglement",
    "originalSrc": "/images/portfolio-mechanical-entanglement.jpg",
    "originalWidth": 2442,
    "originalHeight": 1910,
    "widths": [
      480,
      800,
      1200,
      1800,
      2400,
      2442
    ]
  },
  "portfolio-tech-and-text": {
    "stem": "portfolio-tech-and-text",
    "originalSrc": "/images/portfolio-tech-and-text.jpg",
    "originalWidth": 1988,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      1988
    ]
  },
  "portfolio-through-the-screen": {
    "stem": "portfolio-through-the-screen",
    "originalSrc": "/images/portfolio-through-the-screen.jpg",
    "originalWidth": 1995,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      1995
    ]
  },
  "portfolio-traditional-choice": {
    "stem": "portfolio-traditional-choice",
    "originalSrc": "/images/portfolio-traditional-choice.jpg",
    "originalWidth": 1557,
    "originalHeight": 2048,
    "widths": [
      480,
      800,
      1200,
      1557
    ]
  },
  "portfolio-upgrading-mind": {
    "stem": "portfolio-upgrading-mind",
    "originalSrc": "/images/portfolio-upgrading-mind.jpg",
    "originalWidth": 2011,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      2011
    ]
  },
  "portfolio-urban-abyss": {
    "stem": "portfolio-urban-abyss",
    "originalSrc": "/images/portfolio-urban-abyss.jpg",
    "originalWidth": 2061,
    "originalHeight": 2500,
    "widths": [
      480,
      800,
      1200,
      1800,
      2061
    ]
  }
};
